export default {
  no_results: {
    title: 'Geen resultaten voor "{{search}}"',
    desc: 'Sorry, we konden geen overeenkomst vinden. Probeer een andere zoekterm.',
  },
  empty_menu: {
    title: 'Nog geen items beschikbaar',
    desc: 'Dit menu heeft momenteel niets te tonen. Kom binnenkort terug.',
  },
};
